module.exports = {
    VUE_APP_BUILD_ENV: process.env.VUE_APP_BUILD_ENV || 'development',
    VUE_APP_GRAPHQL_ENDPOINT: process.env.VUE_APP_GRAPHQL_ENDPOINT || '',
    VUE_APP_SOCKET_URL: process.env.VUE_APP_SOCKET_URL || '',
    VUE_APP_BACKEND_URL: process.env.VUE_APP_BACKEND_URL || ''
}